var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 108,
    height: 114,
    viewBox: "0 0 108 114",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M55.735 80.4332C52.6075 81.5268 51.0141 86.0407 52.6559 89.112C54.2977 92.1891 58.6849 92.9744 61.1719 90.6534C63.6589 88.3325 63.5943 83.5568 61.0642 81.2941C58.5342 79.0313 54.2009 79.8457 52.4998 82.8821",
    fill: "#B46464"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37 43.9717C38.1102 37.8905 42.4739 32.5203 48.1604 30.2463C53.8468 27.9686 60.6654 28.8612 65.5898 32.5277C71.4118 36.8609 74.1011 45.7791 70.0891 51.8603C67.5573 55.6972 63.113 57.6823 58.9067 59.4748C54.7005 61.2674 50.2562 63.2525 47.728 67.0931C45.1999 70.9336 45.7605 77.189 49.9594 79",
    stroke: "#B46464",
    strokeWidth: 7,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M41.6505 15.6534C57.2451 5.75749 74.7696 8.06919 87.1724 18.5792C99.6551 29.1591 105.246 48.786 103.34 64.5585C101.43 80.3809 92.1994 95.0849 78.9887 103.922C64.3417 113.718 45.6452 109.919 30.9433 102.494C17.1192 95.5143 7.30964 81.6191 4.72634 66.4058C3.46461 58.9815 3.84861 51.2825 5.86339 44.0328C10.4415 27.5164 24.52 9.05777 43.775 4",
    stroke: "#B46464",
    strokeWidth: 7,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQa);
export default __webpack_public_path__ + "static/media/qa.ca627d1817e4262c14682eac7ad3bea3.svg";
export { ForwardRef as ReactComponent };